export function noopReducer<T>(defaults: T | null = null) {
  return (state: T | null | undefined): T | null => {
    return state || defaults;
  };
}
